import React from 'react';
import PropTypes from 'prop-types';

const CalculationItem = props => {
  const {amount, text, isColumn} = props
  return (
    <p className="s-mb-0 s-color-light-text">
      {amount} {isColumn && <br/>} (<span className="s-color-blue">{text}</span>)
    </p>
  );
};

CalculationItem.propTypes = {
  amount: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isColumn: PropTypes.bool,
};

CalculationItem.defaultProps = {
  isColumn: false,
}

export default CalculationItem;
